import type {
  ApiFetchBannersPort,
  Banner,
} from '~/handlers/ports/api-fetch-banners.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoRequestHeaders } from '~/utils/apostatudo/get-apostatudo-request-headers';

export class ApostatudoApiFetchBannersAdapter implements ApiFetchBannersPort {
  async handle() {
    const response = await fetch(`${getApostatudoApiUrl()}/banners`, {
      method: 'GET',
      headers: { Accept: 'application/json', ...getApostatudoRequestHeaders() },
    });

    // Se a resposta não for OK (404, 500, etc), retorna arrays vazios
    if (!response.ok) {
      console.warn(
        `[ApiFetchBanners] API returned ${response.status}: ${response.statusText}`,
      );

      return {
        home_banners: [],
        side_banners: [],
      };
    }

    const data = await response.json();

    // Verifica se a resposta tem a estrutura esperada
    if (
      typeof data !== 'object' ||
      !Array.isArray(data.home_banners) ||
      !Array.isArray(data.side_banners)
    ) {
      console.warn(
        '[ApiFetchBanners] API response has invalid structure:',
        data,
      );

      return {
        home_banners: [],
        side_banners: [],
      };
    }

    const mapBanner =
      (type: 'HOME_BANNER' | 'MAIN_BANNER') =>
      (item: any): Banner => ({
        id: item.id,
        filename: item.filename,
        // Mantém a URL original da API (pode ter /mobile, /ipad, /public)
        url: item.url,
        link_url: item.link_url || null,
        button_text: item.button_text || null,
        type,
        created_at: item.created_at,
        updated_at: item.updated_at,
      });

    return {
      home_banners: data.home_banners.map(mapBanner('HOME_BANNER')),
      side_banners: data.side_banners.map(mapBanner('MAIN_BANNER')),
    };
  }
}
